import { render, staticRenderFns } from "./act.vue?vue&type=template&id=29268615&"
import script from "./act.vue?vue&type=script&lang=js&"
export * from "./act.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports